import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/Testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials-section" id="testimonials">
       
      <div className="container">
      <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#testimonials" className="section-link">Feature</a>
          <h2 className="news-title">What's in store</h2>
        </motion.div>
        <motion.div 
          className="testimonial-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="testimonial-image">
            {/* This will be replaced with an actual image in production */}
          </div>
          <div className="testimonial-content">
            <div className="testimonial-header">
              <h3 className="testimonial-title">Meet the Sensmeiers</h3>
            </div>
            <div className="testimonial-quote">
              <span className="quote-mark">"</span>
              <p className="quote-text">
                Being able to get a good meal and over-the-counter medicines by drone has been really handy and convenient... It kept us in this house a couple years longer than we would have been able to stay otherwise.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
